import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TileComponent, MenuComponent, ButtonIconComponent, IMenu } from '@tecalisdev/infinity';
import { IWorkflowDetailResponse } from '../../../models/workflows.models';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { WorkflowsHelperService } from '../../../services/workflows-helper.service';

@Component({
	selector: 'app-workflows-detail-json-view',
	imports: [TranslatePipe, TileComponent, MenuComponent, ButtonIconComponent, NgxJsonViewerModule],
	templateUrl: './workflows-detail-json-view.component.html',
	styleUrl: './workflows-detail-json-view.component.scss',
})
export class WorkflowsDetailJsonViewComponent {
	@Input() detail: IWorkflowDetailResponse;
	@Output() dataJsonMenuChange = new EventEmitter<IMenu>();

	public workflowsHelper = inject(WorkflowsHelperService);

	public onDataJsonMenuChange($event: IMenu): void {
		this.dataJsonMenuChange.emit($event);
	}
}
